module.exports = __webpack_public_path__ + "static/img/3113-02.6fb925e1.jpg";